import type { RampConfig } from '@gorampe/calc-engine';
import type { SceneLayout } from '../types';
import { layoutStraight } from './layoutStraight';
import { layoutL90 } from './layoutL90';
import { layoutU180 } from './layoutU180';
import { layoutSwitchback } from './layoutSwitchback';
import { layoutFreeform } from './layoutFreeform';

export function dispatchLayout(config: RampConfig): SceneLayout {
  switch (config.shape.kind) {
    case 'straight':
      return layoutStraight(config, config.shape.totalRunIn);
    case 'L90':
      return layoutL90(config, config.shape);
    case 'U180':
      return layoutU180(config, config.shape);
    case 'switchback':
      return layoutSwitchback(config, config.shape);
    case 'freeform':
      return layoutFreeform(config, config.shape);
  }
}

export { layoutStraight } from './layoutStraight';
export { layoutL90 } from './layoutL90';
export { layoutU180 } from './layoutU180';
export { layoutSwitchback } from './layoutSwitchback';
export { layoutFreeform } from './layoutFreeform';
